import { GetAddAppPermission, getCategoryList, GetCheckAppPermission, getApplicationList, getAppAreaList, getActiveCategory, getCheckCategory, GetAddCategory, getAppPermissionListing, getAppPermissionById, getDeleteAppPermission, getCheckAppArea, GetAddAppArea, getAppAreaById, getDeleteAppArea, getCheckApplication, GetAddApplication, getDeleteCategory, getCategoryById, getActiveApplication, getActiveAppArea, getApplicationById, getDeleteApplication, getSecurityPermissionList, getSecurityRoleList, getActiveRoles, GetAddSecurityRole, getSecurityRoleById, getDeleteSecurityRole, getCheckUser } from "./action";

const dispatchGetCategoryList = (dispatch: Function) => () => {
  dispatch(getCategoryList());
}
const dispatchGetAddAppPermission = (dispatch: Function) => (order: any) => {
  dispatch(GetAddAppPermission(order));
};
const dispatchAddSecurityrole = (dispatch: Function) => (order: any) => {
  dispatch(GetAddSecurityRole(order));
};
const dispatchGetCheckAppPermission = (dispatch: Function) => (order: any) => {
  dispatch(GetCheckAppPermission(order));
};
const dispatchGetApplicationList = (dispatch: Function) => () => {
  dispatch(getApplicationList());
};
const dispatchGetAppAreaList = (dispatch: Function) => () => {
  dispatch(getAppAreaList());
};
const dispatchGetActiveCategory = (dispatch: Function) => () => {
  dispatch(getActiveCategory());
};
const dispatchGetCheckCategory = (dispatch: Function) => (order: any) => {
  dispatch(getCheckCategory(order));
};
const dispatchGetAddCategory = (dispatch: Function) => (order: any) => {
  dispatch(GetAddCategory(order));
};
const dispatchAppPermissionListing = (dispatch: Function) => (val: any) => {
  dispatch(getAppPermissionListing(val));
};
const dispatchAppPermissionById = (dispatch: Function) => (val: any) => {
  dispatch(getAppPermissionById(val));
};
const dispatchSecurityRoleById = (dispatch: Function) => (val: any) => {
  dispatch(getSecurityRoleById(val));
};
const dispatchDeleteAppPermission = (dispatch: Function) => (val: any) => {
  dispatch(getDeleteAppPermission(val));
};
const dispatchDeleteSecurityRole = (dispatch: Function) => (val: any) => {
  dispatch(getDeleteSecurityRole(val));
};
const dispatchGetCheckAppArea = (dispatch: Function) => (order: any) => {
  dispatch(getCheckAppArea(order));
};
const dispatchGetAddAppArea = (dispatch: Function) => (order: any) => {
  dispatch(GetAddAppArea(order));
};
const dispatchAppAreaById = (dispatch: Function) => (val: any) => {
  dispatch(getAppAreaById(val));
};
const dispatchDeleteAppArea = (dispatch: Function) => (val: any) => {
  dispatch(getDeleteAppArea(val));
};
const dispatchGetCheckApplication = (dispatch: Function) => (order: any) => {
  dispatch(getCheckApplication(order));
};
const dispatchGetAddApplication = (dispatch: Function) => (order: any) => {
  dispatch(GetAddApplication(order));
};
const dispatchDeleteCategory = (dispatch: Function) => (val: any) => {
  dispatch(getDeleteCategory(val));
};
const dispatchGetCategoryById = (dispatch: Function) => (val: any) => {
  dispatch(getCategoryById(val));
};
const dispatchGetActiveApplication = (dispatch: Function) => () => {
  dispatch(getActiveApplication());
};
const dispatchGetActiveAppArea = (dispatch: Function) => (val: any) => {
  dispatch(getActiveAppArea(val));
};
const dispatchApplicationById = (dispatch: Function) => (val: any) => {
  dispatch(getApplicationById(val));
};
const dispatchDeleteApplication = (dispatch: Function) => (val: any) => {
  dispatch(getDeleteApplication(val));
};
const dispatchGetSecurityPermissionList = (dispatch: Function) => (val: any) => {
  dispatch(getSecurityPermissionList(val));
};
const dispatchGetSecurityRoleList = (dispatch: Function) => (val: any) => {
  dispatch(getSecurityRoleList(val));
};
const dispatchGetActiveRoles = (dispatch: Function) => (val: any) => {
  dispatch(getActiveRoles(val));
};
const dispatchGetCheckUser = (dispatch: Function) => (order: any) => {
  dispatch(getCheckUser(order));
};

const operations = {
  dispatchGetCategoryList,
  dispatchGetAddAppPermission,
  dispatchGetCheckAppPermission,
  dispatchGetApplicationList,
  dispatchGetAppAreaList,
  dispatchGetActiveCategory,
  dispatchGetCheckCategory,
  dispatchGetAddCategory,
  dispatchAppPermissionListing,
  dispatchAppPermissionById,
  dispatchSecurityRoleById,
  dispatchDeleteAppPermission,
  dispatchDeleteSecurityRole,
  dispatchGetCheckAppArea,
  dispatchGetAddAppArea,
  dispatchAppAreaById,
  dispatchDeleteAppArea,
  dispatchGetCheckApplication,
  dispatchGetAddApplication,
  dispatchDeleteCategory,
  dispatchGetCategoryById,
  dispatchGetActiveApplication,
  dispatchGetActiveAppArea,
  dispatchApplicationById,
  dispatchDeleteApplication,
  dispatchGetSecurityPermissionList,
  dispatchGetSecurityRoleList,
  dispatchGetActiveRoles,
  dispatchAddSecurityrole,
  dispatchGetCheckUser
}

export default operations